import request from "@/utils/request";
import { IEviUpperchain } from "../model/eviupperchain";

// 实体
export const defaultEviUpperchainData: IEviUpperchain = {
  id: "",
  nationalTimeRecordId: "",
  memberId: "",
  serviceData: "",
  messageDigest: "",
  privateKeySign: "",
  status: 0,
  ts: 0,
  ctsr: "",
  createTime: 0
};

export const getEviUpperchain = (id: any) => {
  request({
    url: "/EviUpperchain/Get",
    method: "post",
    params: { id: id }
  });
};

export const addEviUpperchain = (data: any) =>
  request({
    url: "/EviUpperchain/Add",
    method: "post",
    data
  });

export const updateEviUpperchain = (data: any) =>
  request({
    url: "/EviUpperchain/Update",
    method: "post",
    data
  });

export const deleteEviUpperchain = (id: string) =>
  request({
    url: "/EviUpperchain/Delete",
    method: "post",
    params: { id: id }
  });

export const getEviUpperchainPageList = (data: any) =>
  request({
    url: "/EviUpperchain/GetPageListAsync",
    method: "post",
    data
  });

export const getCurrectNotUpperchainDic = () =>
  request({
    url: "/EviUpperchain/GetCurrectNotUpperchainDic",
    method: "post"
  });

export const getCurrectNotCollectDic = () =>
  request({
    url: "/EviUpperchain/GetCurrectNotCollectDic",
    method: "post"
  });
